/**
 * Bottom Navigation Bar — cart badge, tab navigation and the menu screen.
 */
(function () {
  var cartBtn = document.getElementById('bottom-nav-cart');
  var menuBtn = document.getElementById('bottom-nav-menu');
  var homeBtn = document.getElementById('bottom-nav-home');
  var badge = document.getElementById('bottom-nav-badge');
  var allTabs = [homeBtn, cartBtn, menuBtn];

  // --- Active state management ---
  function setActiveTab(tab) {
    allTabs.forEach(function (t) {
      if (t) t.classList.remove('bottom-nav__tab--active');
    });
    if (tab) tab.classList.add('bottom-nav__tab--active');
  }

  function restoreDefaultActive() {
    allTabs.forEach(function (t) {
      if (t) t.classList.remove('bottom-nav__tab--active');
    });
    var path = window.location.pathname;
    if (path === '/' || path === '') {
      if (homeBtn) homeBtn.classList.add('bottom-nav__tab--active');
    } else if (path === '/cart') {
      if (cartBtn) cartBtn.classList.add('bottom-nav__tab--active');
    }
  }

  // --- Cart badge sync ---
  // Initial count is server-rendered into the badge (data-count), so no
  // /cart.js fetch is needed at boot.
  var currentCount = badge ? parseInt(badge.getAttribute('data-count'), 10) || 0 : 0;
  var lastDirectAt = 0; // when an event-carried count was last applied
  var fetchSeq = 0; // discards out-of-order /cart.js responses

  function renderBadge(count) {
    if (!badge) return;
    currentCount = Math.max(0, count);
    badge.textContent = currentCount > 99 ? '99+' : String(currentCount);
    badge.classList.toggle('bottom-nav__badge--visible', currentCount > 0);
  }

  function updateCartBadge(event) {
    // Optimistic path: events that already carry the count update instantly,
    // skipping the extra /cart.js round-trip. Events sourced from
    // 'product-form-component' carry a DELTA on the current count (the same
    // contract cart-icon.js uses for the header bubble); everything else
    // carries the absolute cart count.
    var data = event && event.detail && event.detail.data;
    var known = data && data.itemCount;
    if (typeof known === 'number' && !isNaN(known)) {
      lastDirectAt = performance.now();
      renderBadge(data.source === 'product-form-component' ? currentCount + known : known);
      return;
    }
    // Fallback: fetch the count. A response is STALE — and must be discarded,
    // not rendered — if an event-carried count arrived while it was in flight
    // (it predates that update; rendering it makes the badge jump backwards),
    // or if a newer fetch has started since.
    var seq = ++fetchSeq;
    var startedAt = performance.now();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (seq !== fetchSeq || lastDirectAt > startedAt) return;
        renderBadge(cart.item_count || 0);
      })
      .catch(function () { });
  }

  document.addEventListener('cart:updated', updateCartBadge);
  document.addEventListener('cart:update', updateCartBadge);
  document.addEventListener('cart:refresh', updateCartBadge);
  // The server-rendered count can go stale on a bfcache restore (cart changed
  // on another page, then user hits Back) — only then re-fetch it.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) updateCartBadge();
  });

  // --- Idle prefetch of common navigation targets (home, cart) ---
  // Injected after load + idle so the prefetches never compete with the
  // page's own critical resources (they used to be <link> tags in <head>).
  (function () {
    function injectPrefetches() {
      var nav = document.getElementById('bottom-nav');
      var targets = nav
        ? [nav.getAttribute('data-root-url'), nav.getAttribute('data-cart-url')]
        : ['/', '/cart'];
      targets.forEach(function (path) {
        if (!path || window.location.pathname === path) return; // never prefetch the current page
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = path;
        link.as = 'document';
        document.head.appendChild(link);
      });
    }
    function schedule() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(injectPrefetches, { timeout: 5000 });
      } else {
        setTimeout(injectPrefetches, 2000);
      }
    }
    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }
  })();

  // --- Navigation loading indicator ---
  var navTimeout;
  function startNavigation() {
    document.body.classList.add('is-navigating');
    clearTimeout(navTimeout);
    // Safety net: clear after 8s no matter what
    navTimeout = setTimeout(stopNavigation, 8000);
  }
  function stopNavigation() {
    document.body.classList.remove('is-navigating');
    clearTimeout(navTimeout);
  }

  // Clear on load (covers iOS bfcache restoring the class) and when tab becomes visible again
  window.addEventListener('pageshow', stopNavigation);
  // A bfcache restore (back gesture from the cart) brings the page back with
  // the tab that was tapped still lit; light the one for this page instead.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) restoreDefaultActive();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') stopNavigation();
  });
  // Clear if the user cancels (e.g. back button, new click) — any scroll/touch after arrival means we're done
  window.addEventListener('pagehide', stopNavigation);

  // --- Menu screen ("Nabídka", snippets/app-menu.liquid) ---
  // An opaque screen between the page and the tab bar. Open state is one
  // class on the panel plus `app-menu-open` on <html> (scroll lock, hides the
  // sticky row above the tabs). Opening pushes a history entry so the phone's
  // Back gesture closes the menu instead of leaving the page; links inside
  // replace that entry, so Back from the next page returns to the page the
  // menu was opened on, not to a stale copy of it with the menu up.
  var menu = document.getElementById('app-menu');
  var menuOpen = false;
  var menuHistoryPushed = false;
  var menuHideTimer = 0;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ANIM_MS = 240;

  // A reload while the menu entry is current leaves its state behind; drop it
  // so the next open pushes a fresh entry.
  try {
    if (history.state && history.state.appMenu) history.replaceState(null, '');
  } catch (e) { }

  function menuAnimates() {
    return !reducedMotion.matches;
  }

  // Everything but the menu, the tab bar and the consent banner is inert
  // while the menu is up: no focus or screen-reader wandering behind it.
  function setPageInert(on) {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === menu || el.id === 'bottom-nav' || el.id === 'bottom-nav-progress') return;
      if (/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(el.tagName)) return;
      if (/^shopify-(pc|privacy)/.test(el.id)) return;
      if (on) {
        if (!el.inert) {
          el.inert = true;
          el.setAttribute('data-app-menu-inert', '');
        }
      } else if (el.hasAttribute('data-app-menu-inert')) {
        el.inert = false;
        el.removeAttribute('data-app-menu-inert');
      }
    });
  }

  function showMenuScreen(name) {
    if (!menu) return;
    menu.querySelectorAll('[data-app-menu-screen]').forEach(function (screen) {
      var key = screen.getAttribute('data-app-menu-screen');
      if (key === 'root') {
        screen.inert = name !== 'root';
        return;
      }
      if (key === name) {
        screen.hidden = false;
        screen.inert = false;
        void screen.offsetWidth; // start the slide from off-screen
        screen.classList.add('is-active');
        screen.focus({ preventScroll: true });
      } else if (!screen.hidden) {
        screen.classList.remove('is-active');
        screen.inert = true;
        var hide = function () {
          if (!screen.classList.contains('is-active')) screen.hidden = true;
        };
        if (menuOpen && menuAnimates()) setTimeout(hide, ANIM_MS); else hide();
      }
    });
  }

  function openMenu() {
    if (!menu || menuOpen) return;
    menuOpen = true;
    clearTimeout(menuHideTimer);
    menu.hidden = false;
    void menu.offsetHeight; // start the fade from the closed state
    menu.classList.add('is-open');
    document.documentElement.classList.add('app-menu-open');
    setPageInert(true);
    setActiveTab(menuBtn);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    try {
      history.pushState({ appMenu: true }, '');
      menuHistoryPushed = true;
    } catch (e) {
      menuHistoryPushed = false;
    }
    menu.focus({ preventScroll: true });
  }

  /**
   * @param {{instant?: boolean, viaHistory?: boolean, keepFocus?: boolean}} [opts]
   *   viaHistory: the history entry is already gone (Back gesture, bfcache
   *   restore, navigation), so do not step back again.
   */
  function closeMenu(opts) {
    if (!menu || !menuOpen) return;
    opts = opts || {};
    menuOpen = false;
    menu.classList.remove('is-open');
    document.documentElement.classList.remove('app-menu-open');
    setPageInert(false);
    restoreDefaultActive();
    if (menuBtn) {
      menuBtn.setAttribute('aria-expanded', 'false');
      if (!opts.keepFocus) menuBtn.focus({ preventScroll: true });
    }

    var finish = function () {
      if (menuOpen) return;
      menu.hidden = true;
      showMenuScreen('root');
      var filter = menu.querySelector('[data-app-menu-filter]');
      if (filter && filter.value) {
        filter.value = '';
        filterCountries('');
      }
    };
    clearTimeout(menuHideTimer);
    if (opts.instant || !menuAnimates()) finish(); else menuHideTimer = setTimeout(finish, ANIM_MS);

    if (menuHistoryPushed) {
      menuHistoryPushed = false;
      if (!opts.viaHistory) history.back();
    }
  }

  // Leave the page from inside the menu: replace the menu's history entry
  // rather than stacking a new one on top of it.
  function navigateFromMenu(href) {
    startNavigation();
    if (menuHistoryPushed) {
      location.replace(href);
    } else {
      location.href = href;
    }
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function filterCountries(query) {
    if (!menu) return;
    var q = normalizeText(query);
    menu.querySelectorAll('[data-app-menu-country]').forEach(function (li) {
      li.hidden = q !== '' && normalizeText(li.getAttribute('data-app-menu-country')).indexOf(q) === -1;
    });
  }

  if (menu) {
    menu.addEventListener('click', function (e) {
      var target = e.target instanceof Element ? e.target : null;
      if (!target) return;

      if (target.closest('[data-app-menu-close]')) {
        e.preventDefault();
        closeMenu();
        return;
      }
      if (target.closest('[data-app-menu-back]')) {
        e.preventDefault();
        showMenuScreen('root');
        var rootScreen = menu.querySelector('[data-app-menu-screen="root"]');
        if (rootScreen) rootScreen.focus({ preventScroll: true });
        return;
      }
      var push = target.closest('[data-app-menu-push]');
      if (push) {
        e.preventDefault();
        showMenuScreen(push.getAttribute('data-app-menu-push'));
        return;
      }
      if (target.closest('[data-app-menu-search]')) {
        e.preventDefault();
        closeMenu({ keepFocus: true });
        var searchBtn = document.getElementById('mobile-header-search');
        if (searchBtn) searchBtn.click();
        return;
      }

      var countryBtn = target.closest('[data-country-code]');
      if (countryBtn) {
        e.preventDefault();
        var form = countryBtn.closest('form');
        var code = countryBtn.getAttribute('data-country-code');
        if (!form) return;
        if (countryBtn.getAttribute('aria-current') === 'true') {
          showMenuScreen('root');
          return;
        }
        var input = form.querySelector('input[name="country_code"]');
        if (input) input.value = code;
        startNavigation();
        // Step off the menu's history entry first, so the market switch does
        // not leave it behind; submit once the step lands.
        if (menuHistoryPushed) {
          menuHistoryPushed = false;
          window.addEventListener('popstate', function () { form.submit(); }, { once: true });
          history.back();
        } else {
          form.submit();
        }
        return;
      }

      var link = target.closest('a[href]');
      if (!link || e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var href = link.getAttribute('href') || '';
      if (href === '' || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(href)) return;
      if (link.getAttribute('target') === '_blank' || link.hasAttribute('download')) return;
      var url;
      try {
        url = new URL(link.href, location.href);
      } catch (err) {
        return;
      }
      e.preventDefault();
      if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search) {
        closeMenu();
        return;
      }
      navigateFromMenu(url.href);
    });

    menu.addEventListener('input', function (e) {
      var input = e.target instanceof Element ? e.target.closest('[data-app-menu-filter]') : null;
      if (input) filterCountries(input.value);
    });

    // Enter in the country filter must not submit the form with the current country
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target instanceof Element && e.target.matches('[data-app-menu-filter]')) {
        e.preventDefault();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuOpen) closeMenu();
    });

    // Back gesture / browser Back while the menu is up
    window.addEventListener('popstate', function () {
      if (menuOpen) closeMenu({ instant: true, viaHistory: true, keepFocus: true });
    });

    // Restored from bfcache after leaving through a menu link: the snapshot
    // still has the menu up and its history entry is gone.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && menuOpen) {
        menuHistoryPushed = false;
        closeMenu({ instant: true, viaHistory: true, keepFocus: true });
      }
    });

    // Rotated or resized past the phone breakpoint: the tab bar is gone
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var onBreakpoint = function (q) {
      if (!q.matches && menuOpen) closeMenu({ instant: true, keepFocus: true });
    };
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpoint);
  }

  // --- Home button ---
  if (homeBtn) {
    homeBtn.addEventListener('click', function (e) {
      var onHome = window.location.pathname === '/' || window.location.pathname === '';
      if (menuOpen) {
        e.preventDefault();
        if (onHome) {
          closeMenu({ keepFocus: true });
        } else {
          setActiveTab(homeBtn);
          sessionStorage.setItem('_bnav_active', 'bottom-nav-home');
          navigateFromMenu(homeBtn.href);
        }
        return;
      }

      // If already on home, don't reload
      if (onHome) {
        e.preventDefault();
      } else {
        setActiveTab(homeBtn);
        sessionStorage.setItem('_bnav_active', 'bottom-nav-home');
        startNavigation();
      }
    });
  }

  // --- Cart button ---
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var onCart = window.location.pathname === '/cart';

      if (menuOpen) {
        if (onCart) {
          closeMenu({ keepFocus: true });
        } else {
          setActiveTab(cartBtn);
          sessionStorage.setItem('_bnav_active', 'bottom-nav-cart');
          navigateFromMenu('/cart');
        }
        return;
      }

      if (!onCart) {
        setActiveTab(cartBtn);
        sessionStorage.setItem('_bnav_active', 'bottom-nav-cart');
        startNavigation();
        window.location.href = '/cart';
      }
    });
  }

  // --- Menu button: the menu screen is a toggle ---
  if (menuBtn) {
    menuBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (menuOpen) {
        closeMenu({ keepFocus: true });
      } else {
        openMenu();
      }
    });
  }

  // --- Shopify Chat bubble: raise above bottom nav (and sticky cart when active) ---
  (function () {
    var navHeight = 0;

    // Lift the bubble with a transform — never touch Inbox's inline `bottom`.
    // Inbox owns that property and rewrites it when the chat window opens
    // fullscreen; overriding it mid-open left the open window positioned
    // off-screen with page scroll locked, and Inbox persists the open state,
    // so reloads stayed broken until the visitor cleared site data.
    function safeApply() {
      var chatEl = document.getElementById('ShopifyChat');
      if (!chatEl) return;

      // Computed fresh on every call: when the bubble is tapped, Inbox
      // rewrites the inline style before any ResizeObserver callback runs,
      // so a cached fullscreen flag is stale exactly when it matters.
      var isFullscreen = chatEl.offsetHeight > (window.innerHeight * 0.8);

      var expected = '';
      if (!isFullscreen) {
        var sc = document.getElementById('bottom-nav-sticky-cart');
        var isStickyVisible = (sc && sc.classList.contains('bottom-nav__sticky-cart--active'));
        // Sticky-cart row is position:absolute above the nav, ~60px tall
        expected = 'translateY(' + -(navHeight + 6 + (isStickyVisible ? 60 : 0)) + 'px)';
      }

      if (chatEl.style.transform !== expected) {
        chatEl.style.transform = expected;
      }
    }

    var navEl = document.getElementById('bottom-nav');
    function refreshNavHeight() {
      navHeight = navEl ? navEl.offsetHeight : 80;
      safeApply();
    }
    refreshNavHeight();
    if (navEl && window.ResizeObserver) {
      new ResizeObserver(refreshNavHeight).observe(navEl);
    }

    // Poll until #ShopifyChat appears (bounded), then rely on observers only
    var attempts = 0;
    function poll() {
      var chatEl = document.getElementById('ShopifyChat');
      if (chatEl) {
        if (!chatEl._bnavResizeObs && window.ResizeObserver) {
          chatEl._bnavResizeObs = new ResizeObserver(safeApply);
          chatEl._bnavResizeObs.observe(chatEl);
        }
        // Shopify's script occasionally rewrites the inline style without a
        // resize; re-check ours. No loop: safeApply only writes on mismatch.
        if (!chatEl._bnavStyleObs) {
          chatEl._bnavStyleObs = new MutationObserver(safeApply);
          chatEl._bnavStyleObs.observe(chatEl, { attributes: true, attributeFilter: ['style'] });
        }
        safeApply();
        return;
      }
      if (++attempts < 40) setTimeout(poll, 500);
    }
    poll();

    // Re-apply when sticky cart toggles
    var stickyCartEl = document.getElementById('bottom-nav-sticky-cart');
    if (stickyCartEl) {
      new MutationObserver(safeApply).observe(stickyCartEl, {
        attributes: true, attributeFilter: ['class']
      });
    }

    window.addEventListener('resize', refreshNavHeight);
  })();

  // --- Global: show progress bar on any same-origin link navigation ---
  // Bubble phase (not capture), so JS-handled links (filters, load-more, any
  // component that preventDefaults) have already marked the event — otherwise
  // the page dims for a navigation that never happens and stays faded until
  // the 8s safety timeout.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    // Modified clicks open a new tab/window — this page stays put.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') ||
      href.startsWith('tel:') || href.startsWith('javascript:') ||
      link.getAttribute('target') === '_blank' || link.hasAttribute('download')) return;
    // Only same-origin links
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
    } catch (err) { return; }
    startNavigation();
  });
})();
